

import { useState, useEffect } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";




export const AutocompleteConLoading = ({
    label,
    name,
    options = [],
    value=null,
    bloqueo = false,
    loading = false,
    handleFunction = null,  
    onChange,              
    ...props
}) => {


    const [selectedValue, setSelectedValue] = useState(null);


    useEffect(() => {
        setSelectedValue(value?.id || null);
    }, [value]);

    
    const handleSelect = (newValue) => {
        const val = newValue ? newValue.id : null;
        setSelectedValue(val);

        if (onChange) {
            onChange(newValue);
        }
    };

    const handleInputChange = (_, inputValue) => {
        if (handleFunction) {
        handleFunction(inputValue);
        }
    };




    return (
        <>
            <Autocomplete
                disabled={bloqueo}
                loading={loading}
                value={options.find((opt) => opt.id === selectedValue) || null}
                options={options}
                onChange={(_, newValue) => handleSelect(newValue)}
                onInputChange={handleInputChange}
                getOptionLabel={(option) => option.nombre || ""}
                isOptionEqualToValue={(option, value) => 
                    (option.id || option._id) === (value.id || value._id)
                }
                renderOption={(props, option) => {
                    const { key, ...otherProps } = props;
                    return ( <li key={key} {...otherProps}> {option.nombre}</li> );
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        {...props}
                        label={label}
                        autoComplete="off"
                        InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                            {loading && <CircularProgress color="inherit" size={20} />}
                            {params.InputProps.endAdornment}
                            </>
                        ),
                        }}
                    />
                )}
            />
        </>
    );
};
